import {Moment} from 'moment';
import React from 'react';

import PositionedPopover from 'ui-library/PositionedPopover';

import NewEntryPopoverContent from './NewEntryPopoverContent';

interface NewEntryPositionedPopoverProps {
  left: number;
  top: number;
  startDate: Moment;
  endDate: Moment;
}

function NewEntryPositionedPopover({
  left,
  top,
  startDate,
  endDate,
}: NewEntryPositionedPopoverProps): JSX.Element {
  return (
    <PositionedPopover className="u-position-fixed" left={left} top={top}>
      <NewEntryPopoverContent startDate={startDate} endDate={endDate} />
    </PositionedPopover>
  );
}

export default NewEntryPositionedPopover;
